<template>
  <div class="content album-add-page">
    <el-form
        :model="createAlbumRequest"
        :rules="rules"
        ref="createAlbumRequest"
        label-width="120px"
        class="demo-ruleForm album-form"
    >
      <div class="page-header-card">
        <div>
          <h2 class="page-title">Tạo album mới</h2>
          <p class="page-description">
            Điền thông tin album, chọn đối tượng hiển thị và tải ảnh lên theo đúng giới hạn hệ thống.
          </p>
        </div>
        <div class="header-badges">
          <div class="summary-badge">
            <span class="summary-badge__label">Đối tượng</span>
            <strong class="summary-badge__value">
              {{ createAlbumRequest.selectObject === 'student' ? 'Lớp' : 'Trường' }}
            </strong>
          </div>
        </div>
      </div>

      <div class="form-shell">
        <section class="section-card">
          <div class="section-heading">
            <div>
              <h3 class="section-title">Thông tin album</h3>
              <p class="section-description">Nhập thông tin cơ bản để tạo album mới.</p>
            </div>
          </div>

          <el-row :gutter="20">
            <el-col :xs="24" :md="12">
              <el-form-item class="field-item" label="Tên album" prop="albumName">
                <el-input
                    v-model="createAlbumRequest.albumName"
                    placeholder="Nhập tên album"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :md="12">
              <el-form-item class="field-item" label="Đối tượng">
                <el-select
                    @change="handleChangeObject"
                    v-model="createAlbumRequest.selectObject"
                    placeholder="Chọn đối tượng"
                    class="full-width"
                >
                  <el-option
                      v-for="item in listSelectObject"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value"
                  >
                    <span>{{ item.label }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item class="description-item" label="Mô tả" prop="desc">
            <el-input
                :rows="4"
                v-model="createAlbumRequest.albumDescription"
                placeholder="Nhập mô tả cho album"
                type="textarea"
            ></el-input>
          </el-form-item>
        </section>

        <section v-if="createAlbumRequest.selectObject === 'student'" class="section-card">
          <div class="section-heading section-heading--space-between">
            <div>
              <h3 class="section-title">Phạm vi học sinh</h3>
              <p class="section-description">Chọn học sinh áp dụng cho album theo từng lớp.</p>
            </div>

            <el-button
                @click="clickSelectStudent"
                type="primary"
                icon="el-icon-user"
                class="student-select-button"
            >
              Chọn học sinh trong lớp
            </el-button>
          </div>

          <div class="student-list-panel">
            <div class="student-list-panel__header">
              <div>
                <h4 class="student-list-title">Danh sách học sinh</h4>
                <span class="student-list-subtitle">Đã chọn {{ createAlbumRequest.kids.length }} học sinh</span>
              </div>
            </div>

            <div v-if="createAlbumRequest.kids.length === 0" class="student-empty-state">
              <i class="el-icon-user-solid student-empty-state__icon"></i>
              <div class="student-empty-state__title">Chưa có học sinh nào được chọn</div>
              <div class="student-empty-state__desc">
                Nhấn <strong>Chọn học sinh trong lớp</strong> để thêm học sinh vào album này.
              </div>
            </div>

            <div v-else class="answer_apply">
              <div v-for="(kid, index) in createAlbumRequest.kids" :key="index" class="kid-row">
                <div class="kid-row__icon-wrap">
                  <i class="el-icon-circle-check kid-row__icon"/>
                </div>
                <div class="kid-row__content">
                  <div class="kid-row__name">{{ kid.kidsName }}</div>
                  <div class="kid-row__meta">
                    {{ parseKidStatusVietnamese(kid.statusKids) }} • {{ kid.className }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="section-card">
          <div class="section-heading">
            <div>
              <h3 class="section-title">Hình ảnh album</h3>
            </div>
          </div>

          <div class="upload-toolbar">
            <div class="upload-left">
              <div class="upload-note-card">
                <span class="upload-note-card__label">Giới hạn</span>
                <strong class="upload-note-card__value">{{ "Tối đa " + albumMaxNumber + " ảnh" }}</strong>
              </div>

              <div class="selected-summary">
                <template v-if="fileList && fileList.length > 0">
                  <img :src="getPreview(fileList[0])" class="selected-summary__thumb" alt="ảnh"/>
                  <div class="selected-summary__text">{{ fileList.length }} ảnh đã chọn</div>
                  <el-button type="text" @click="clearSelected" class="clear-selected">Xóa</el-button>
                </template>
                <template v-else>
                  <div class="selected-summary__empty">Chưa có ảnh</div>
                </template>
              </div>
            </div>

            <div class="upload-right">
              <div class="progress-wrap">
                <el-progress
                    v-if="showProgress"
                    class="upload-progress"
                    :percentage="percentage"
                    :color="colors"
                ></el-progress>
                <div v-if="showProgress" class="progress-label">{{ percentage }}%</div>
              </div>
            </div>
          </div>

          <el-upload
              action="/api/upload/"
              list-type="picture-card"
              :auto-upload="false"
              :file-list="fileList"
              :on-change="handleChangePicture"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              ref="upload"
              :limit="albumMaxNumber"
              :on-exceed="handleExceed"
              accept="image/*"
              class="upload-area"
          >
            <template #default>
              <div class="upload-trigger">
                <i class="el-icon-plus upload-trigger__icon"></i>
                <span class="upload-trigger__text">Thêm ảnh</span>
              </div>
            </template>

            <template #file="{ file }">
              <div class="container_image_upload">
                <TagFlag title="Mới"/>
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt/>
                <span class="el-upload-list__item-actions">
                  <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                      @click="handleRemove(file)"
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </template>
          </el-upload>
        </section>

        <el-dialog width="30%" :visible.sync="dialogVisible" top="50px">
          <img width="100%" :src="dialogImageUrl" alt/>
        </el-dialog>
      </div>

      <div class="actions-wrap">
        <el-button
            class="button-over"
            type="success"
            :loading="loadingButton"
            :disabled="loadingButton || compressingCount > 0"
            @click="submitUpload('createAlbumRequest')"
            icon="el-icon-circle-check"
        >
          Lưu thay đổi
        </el-button>

        <router-link
            to="/student-quality/album"
            class="router-link cancel-link"
        >
          <el-button
              class="button-over"
              type="danger"
              @click="createEmployeeDialog()"
          >
            <i class="el-icon-circle-close"/>
            Hủy
          </el-button>
        </router-link>
      </div>
    </el-form>

    <AddStudentInAlbumDialog
        :getAppTypeUserLogin="getAppTypeUserLogin"
        :isAddStudentInAlbumDialog="isAddStudentInAlbumDialog"
        @closeDialog="closeAddStudentInAlbumDialog"
        @updateIdKidApply="updateIdKidApply"
        @confirmData="handleConfirmKidsApply"
    />
  </div>
</template>

<script>
import AlbumService from "../../services/AlbumService";
import pica from 'pica';
import {mapState} from "vuex";
import TagFlag from "@/views/tag/TagFlag.vue";
import albumService from "../../services/AlbumService";
import AddStudentInAlbumDialog from "@/views/album/AddStudentInAlbumDialog.vue";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  components: {AddStudentInAlbumDialog, TagFlag},
  data() {
    return {
      colors: [
        {color: "#f56c6c", percentage: 20},
        {color: "#e6a23c", percentage: 40},
        {color: "#5cb87a", percentage: 60},
        {color: "#1989fa", percentage: 80},
        {color: "#6f7ad3", percentage: 100},
      ],
      percentage: 0,
      loadingButton: false,
      createAlbumRequest: {
        albumName: "",
        albumDescription: "",
        albumType: "",
        albumApprovalDefault: false,
        idSchoolApproval: "",
        createdBy: "",
        createdDate: "",
        schoolApprovalDate: "",
        urlPictureFirst: "",
        pictureNumber: "",
        pictureApprovedNumber: "",
        idClass: "",
        idSchool: "",
        alistPictureList: [],
        fileList: [],
        selectObject: "school",
        listIdKidApply: [],
        classes: [],
        kids: [],
      },
      // listClass: [],
      rules: {
        albumName: [
          {
            required: true,
            message: "Tên Album không được được để trống",
            trigger: "blur",
          },
        ],
        idClass: [
          {
            required: true,
            message: "Lớp không được để trống",
            trigger: "blur",
          },
        ],
      },
      // files: [],
      selectedFiles: undefined,
      currentFile: undefined,
      fileInfos: [],
      layout: "sizes, prev, pager, next",
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisiblePic: false,
      indexSrc: "",
      disabled: false,
      showCreateDialog: false,
      showUpdateDialog: false,
      idList: [],
      qualityPicture: "",
      widthPicture: "",
      srcs: [
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%203.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2013.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2014.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2013.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
      ],
      imgUrl: "",
      albumMaxNumber: 0,
      maxSizeListImage: null,
      showProgress: false,
      isAddStudentInAlbumDialog: false,
      idKidApply: [],
      compressingCount: 0,
      compressPromises: [],
      picaResizer: null,
    };
  },
  computed: {
    ...mapState('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),

    listClass() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon;
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      }
      return [];
    },
    // eslint-disable-next-line vue/return-in-computed-property
    listSelectObject() {
      if (this.getAppTypeUserLogin === "plus") {
        return [
          { id: 1, value: "school", label: "Trường" },
          { id: 2, value: "student", label: "Lớp" },
        ];
      } else if (this.getAppTypeUserLogin === "teacher") {
        return [
          { id: 2, value: "student", label: "Lớp" },
        ];
      }
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },
  mixins: [
    parseInfoKidVietnameseMixin,
  ],
  created() {
    this.picaResizer = pica({
      features: ['js', 'wasm', 'ww'],
    });
    this.$store.dispatch('classStore/fetchDataClassListCommon')
    this.getAlbumMaxNumber()
    this.getSyConfigPicture();
    this.fetchSizeListImage();
    if (this.getAppTypeUserLogin === "plus") {
    this.createAlbumRequest.selectObject = "school"
    } else if (this.getAppTypeUserLogin === "teacher") {
      this.createAlbumRequest.selectObject = "student"
    }
    this.handleChangeObject()
  },
  methods: {
    getPreview(file) {
      if (!file) return '';
      const url = file.url || file.thumbUrl;
      if (url) return url;
      if (file.raw && file.raw instanceof File) {
        if (!this._createdPreviews) this._createdPreviews = {};
        if (!this._createdPreviews[file.uid]) {
          this._createdPreviews[file.uid] = URL.createObjectURL(file.raw);
        }
        return this._createdPreviews[file.uid];
      }
      return '';
    },

    formatSize(bytes) {
      if (!bytes) return '';
      const kb = 1024;
      if (bytes < kb) return bytes + ' B';
      const mb = kb * 1024;
      if (bytes < mb) return (bytes / kb).toFixed(1) + ' KB';
      return (bytes / mb).toFixed(1) + ' MB';
    },

    clearSelected() {
      // revoke any object URLs we created for previews
      if (this._createdPreviews) {
        this.fileList.forEach(f => {
          const url = this._createdPreviews[f.uid];
          if (url) {
            try { URL.revokeObjectURL(url); } catch (e) { /* ignore */ }
            delete this._createdPreviews[f.uid];
          }
        });
      }
      this.fileList = [];
      if (this.createAlbumRequest && Array.isArray(this.createAlbumRequest.fileList)) {
        this.createAlbumRequest.fileList = [];
      }
      try { this.$refs.upload.clearFiles(); } catch (e) { /* ignore */ }
    },
    handleChangeObject(){
      if (this.createAlbumRequest.selectObject === "school") {
        this.createAlbumRequest.listIdKidApply = []
        this.createAlbumRequest.classes = []
        this.createAlbumRequest.kids = []
      }
    },
    clickSelectStudent(){
      this.isAddStudentInAlbumDialog = true
    },
    closeAddStudentInAlbumDialog(){
      this.isAddStudentInAlbumDialog = false
    },
    updateIdKidApply(newList) {
      this.idKidApply = newList;
    },
    handleConfirmKidsApply(value) {
      this.createAlbumRequest.classes = value.classesApply;
      this.createAlbumRequest.kids = value.kidsApply;
      this.createAlbumRequest.listIdKidApply = []
      for (let i = 0; i < this.createAlbumRequest.kids.length; i++) {
        this.createAlbumRequest.listIdKidApply.push(this.createAlbumRequest.kids[i].idKid);
      }
      this.closeAddStudentInAlbumDialog();
    },
    getSyConfigPicture() {
      AlbumService.getSyConfigPicture().then((response) => {
        this.qualityPicture = response.data.data.qualityPicture;
        this.widthPicture = response.data.data.widthPicture;
      })
    },
    increase() {
      this.interval = window.setInterval(() => {
        this.percentage += 5;
        if (this.percentage > 90) {
          this.percentage = 90;
        }
      }, 50);
    },
    stopIncrease() {
      clearInterval(this.interval);
      this.percentage = 100;
    },
    handleChangePicture(file, fileList) {
      this.fileList = fileList
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemove(file);
        return false; // Trả về false để không thực hiện tiếp tục xử lý
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemove(file);
        return false; // Trả về false để không thực hiện tiếp tục xử lý
      }
      this.compressingCount += 1;
      const compressPromise = this.compressImage(file.raw, file.name, file.uid)
          .then((compressedFile) => {
            const existedIndex = this.createAlbumRequest.fileList.findIndex(item => item.uid === compressedFile.uid);
            if (existedIndex >= 0) {
              this.createAlbumRequest.fileList.splice(existedIndex, 1, compressedFile);
            } else {
              this.createAlbumRequest.fileList.push(compressedFile);
            }
          })
          .catch((error) => {
            console.error("Compression error:", error);
            this.$message.error(`Nén ảnh thất bại: ${file.name}`);
          })
          .finally(() => {
            this.compressingCount = Math.max(0, this.compressingCount - 1);
          });

      this.compressPromises.push(compressPromise);
      compressPromise.finally(() => {
        this.compressPromises = this.compressPromises.filter(p => p !== compressPromise);
      });
      return true;
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        const objectUrl = URL.createObjectURL(file);
        image.onload = () => {
          URL.revokeObjectURL(objectUrl);
          resolve(image);
        };
        image.onerror = (error) => {
          URL.revokeObjectURL(objectUrl);
          reject(error);
        };
        image.src = objectUrl;
      });
    },
    async compressImage(file, fileName, uid) {
      const image = await this.loadImage(file);
      const maxWidthConfig = parseInt(this.widthPicture);
      const maxWidth = Number.isFinite(maxWidthConfig) && maxWidthConfig > 0 ? maxWidthConfig : 1280;
      const ratio = Math.min(1, maxWidth / image.width);
      const targetWidth = Math.max(1, Math.round(image.width * ratio));
      const targetHeight = Math.max(1, Math.round(image.height * ratio));

      const sourceCanvas = document.createElement('canvas');
      sourceCanvas.width = image.width;
      sourceCanvas.height = image.height;
      const sourceContext = sourceCanvas.getContext('2d');
      sourceContext.drawImage(image, 0, 0);

      const resultCanvas = document.createElement('canvas');
      resultCanvas.width = targetWidth;
      resultCanvas.height = targetHeight;

      await this.picaResizer.resize(sourceCanvas, resultCanvas);

      const qualityConfig = parseInt(this.qualityPicture);
      const quality = Number.isFinite(qualityConfig) && qualityConfig > 0 ? Math.min(1, qualityConfig / 100) : 0.8;
      const outputType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
      const resultBlob = await this.picaResizer.toBlob(resultCanvas, outputType, quality);

      const lastDot = fileName.lastIndexOf('.');
      const originalFilename = lastDot > 0 ? fileName.substring(0, lastDot) : fileName;
      const extension = outputType === 'image/png' ? 'png' : 'jpg';
      const compressedFile = new File([resultBlob], `${originalFilename}_compressed.${extension}`, {type: outputType});
      compressedFile.uid = uid;
      return compressedFile;
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },
    //highlight cho row theo điều kiện
    tableRowStyle({row}) {
      row.id;
    },
    submitUpload(fromData) {
      this.$refs[fromData].validate(async (valid) => {
        if (valid) {
          if (this.compressPromises.length > 0) {
            this.$message.info("Đang nén ảnh, vui lòng chờ...");
            await Promise.allSettled(this.compressPromises);
          }
          if (this.fileList.length > 0 && this.createAlbumRequest.fileList.length === 0) {
            this.$message.warning("Chưa có ảnh hợp lệ sau khi nén. Vui lòng thử lại.");
            return;
          }
          if (this.createAlbumRequest.selectObject === 'school'){
            this.showProgress = true;
            let formData = new FormData();
            this.loadingButton = true;
            this.createAlbumRequest.idClass = "0"
            formData.append("albumName", this.createAlbumRequest.albumName);
            formData.append("albumDescription", this.createAlbumRequest.albumDescription);
            formData.append("idClass", this.createAlbumRequest.idClass);
            formData.append("countFile", this.createAlbumRequest.fileList.length);
            formData.append("selectObject", this.createAlbumRequest.selectObject);
            this.increase();
            AlbumService.createAlbumUploadNew(formData)
                .then(async (res) => {
                  const id = res.data.data;
                  await this.savePictureAlbum(id, this.createAlbumRequest.fileList);
                  // if (this.createAlbumRequest.fileList.length > 0) {
                  //   this.savePictureAlbum(id, this.createAlbumRequest.fileList);
                  // } else {
                  //   this.showProgress = false;
                  //   this.stopIncrease();
                  //   this.$router.push("/student-quality/album");
                  // }
                })
                .catch((err) => {
                  this.showProgress = false;
                  this.loadingButton = false;
                  NotifyMessage.leftCornerNotificationError(err.response.data.message)
                })
                .finally(() => {
                });
          } else {
            if (this.createAlbumRequest.classes.length > 0) {
              for (let i = 0; i < this.createAlbumRequest.classes.length; i++) {
                this.showProgress = true;
                let formData = new FormData();
                this.loadingButton = true;
                formData.append("albumName", this.createAlbumRequest.albumName);
                formData.append("albumDescription", this.createAlbumRequest.albumDescription);
                formData.append("idClass", this.createAlbumRequest.classes[i]);
                formData.append("countFile", this.createAlbumRequest.fileList.length);
                formData.append("listIdKidApply", this.createAlbumRequest.listIdKidApply);
                formData.append("selectObject", this.createAlbumRequest.selectObject);
                this.increase();
                AlbumService.createAlbumUploadNew(formData)
                    .then(async (res) => {
                      const id = res.data.data;
                      await this.savePictureAlbum(id, this.createAlbumRequest.fileList);
                      // if (this.createAlbumRequest.fileList.length > 0) {
                      //   this.savePictureAlbum(id, this.createAlbumRequest.fileList);
                      // } else {
                      //   NotifyMessage.leftCornerNotificationSuccess("Thêm mới Album thành công")
                      //   this.showProgress = false;
                      //   this.stopIncrease();
                      //   this.$router.push("/student-quality/album");
                      // }
                    })
                    .catch((err) => {
                      this.showProgress = false;
                      this.loadingButton = false;
                      NotifyMessage.leftCornerNotificationError(err.response.data.message)
                    })
                    .finally(() => {
                    });
              }
            }
          }

        }
      });
    },

    async savePictureAlbum(id, fileList) {
      const groupFile = this.groupFilesBySize(fileList);

      try {
        // Tạo danh sách Promise upload
        const uploadPromises = groupFile.map(async (child) => {
          const formData = new FormData();
          formData.append("idAlbum", id);
          formData.append("isCreate", true);

          child.forEach((file, i) => {
            formData.append(`fileList[${i}]`, file);
          });

          // Gửi yêu cầu upload
          await AlbumService.savePictureAlbum(formData);
        });

        // Đợi tất cả file upload xong
        await Promise.all(uploadPromises);

        // Khi tất cả thành công, hiển thị thông báo & chuyển trang
        NotifyMessage.leftCornerNotificationSuccess("Thêm mới Album thành công")
        await this.$router.push("/student-quality/album");
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError("Lỗi lưu ảnh!")
      } finally {
        this.showProgress = false;
        this.stopIncrease();
        this.loadingButton = false;
      }
    },

    groupFilesBySize(files) {
      const maxSize = this.maxSizeListImage * 1024 * 1024; // 10MB in bytes
      let groups = [];
      let currentGroup = [];
      let currentSize = 0;

      for (let file of files) {
        const fileSize = file.size;

        // Nếu thêm file này vào nhóm hiện tại không vượt quá 10MB, thêm vào
        if (currentSize + fileSize <= maxSize) {
          currentGroup.push(file);
          currentSize += fileSize;
        } else {
          // Nếu vượt quá, tạo một nhóm mới và thêm file vào nhóm đó
          groups.push(currentGroup);
          currentGroup = [file];
          currentSize = fileSize;
        }
      }

      // Đừng quên thêm nhóm cuối cùng nếu có
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }

      return groups;

    },

    handleCommand(command) {
      switch (command) {
        case "activeAccount" :
          this.updateMultiActivated();
          break;
        case "deleteMultiEmployee" :
          this.handleMultiDelelte();
          break;
        case "exportExcel" :
          this.exportExcelEmployee();
          break;

      }

    },
    handleRemove(file) {
      this.$refs.upload.clearFiles();
      let indexAlbumRequest;
      for (let i = 0; i < this.createAlbumRequest.fileList.length; i++) {
        if (file.uid === this.createAlbumRequest.fileList[i].uid) {
          indexAlbumRequest = i
        }
      }
      let indexFile;
      for (let i = 0; i < this.fileList.length; i++) {
        if (file.uid === this.fileList[i].uid) {
          indexFile = i
        }
      }
      if (indexAlbumRequest >= 0) {
        this.createAlbumRequest.fileList.splice(indexAlbumRequest, 1);
      }
      if (indexFile >= 0) {
        this.fileList.splice(indexFile, 1);
      }
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // handleShowDetailPicture(index) {
    //   this.indexSrc = index;
    //   this.dialogVisiblePic = true;
    // },
    handleDownload(file) {
      console.log(file);
    },
    //click edit at row
    handleEdit(index, row) {
      console.log(row);
    },
    createEmployeeDialog() {
      this.showCreateDialog = true;
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
    },
    dialogCloseUpdateMethod() {
      this.showUpdateDialog = false;
    },
    // handleFile(file) {
    //   console.log(file);
    // },

    handleExceed() {
      let textWarning = "Chỉ được phép chọn tối đa " + this.albumMaxNumber + " ảnh`"
      this.$message.warning(textWarning);
    },
    beforeRemove(file, fileList) {
      console.log(fileList);
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },

    getAlbumMaxNumber() {
      AlbumService.getAlbumMaxNumber()
          .then(response => {
            this.albumMaxNumber = response.data.data
          })
          .catch(error => {
            console.error(error);
          });

    },

    fetchSizeListImage() {
      albumService.getSizeListImage()
          .then(res => this.maxSizeListImage = res.data.data)
          .catch(err => console.error(err))
    }
  },

};
</script>

<style lang="scss" scoped>
.album-add-page {
  padding-bottom: 24px;

  .album-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .page-header-card,
  .form-shell {
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    border: 1px solid #e8edf4;
    border-radius: 18px;
    box-shadow: 0 10px 30px rgba(31, 45, 61, 0.08);
  }

  .page-header-card {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    padding: 24px 28px;
    overflow: hidden;
    position: relative;
  }

  .page-header-card::after {
    content: "";
    position: absolute;
    top: -30px;
    right: -30px;
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(120, 165, 231, 0.22) 0%, rgba(120, 165, 231, 0) 72%);
    pointer-events: none;
  }

  .page-eyebrow {
    margin-bottom: 8px;
    color: #78a5e7;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .page-title {
    margin: 0 0 8px;
    color: #303133;
    font-size: 26px;
    font-weight: 700;
  }

  .page-description {
    margin: 0;
    max-width: 640px;
    color: #606266;
    line-height: 1.6;
  }

  .header-badges {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;
  }

  .summary-badge {
    min-width: 150px;
    padding: 14px 16px;
    border-radius: 14px;
    background: #f5f9ff;
    border: 1px solid #dbe8fb;
  }

  .summary-badge__label {
    display: block;
    margin-bottom: 6px;
    color: #909399;
    font-size: 12px;
  }

  .summary-badge__value {
    color: #303133;
    font-size: 18px;
    font-weight: 700;
  }

  .form-shell {
    padding: 28px;
  }

  .section-card {
    padding: 24px;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid #edf2f8;
  }

  .section-card + .section-card {
    margin-top: 20px;
  }

  .section-heading {
    margin-bottom: 20px;
  }

  .section-heading--space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .section-title {
    margin: 0 0 6px;
    color: #303133;
    font-size: 18px;
    font-weight: 700;
  }

  .section-description {
    margin: 0;
    color: #909399;
    line-height: 1.5;
  }

  .field-item,
  .description-item {
    margin-bottom: 0;
  }

  .description-item {
    margin-top: 8px;
  }

  .full-width,
  .full-width /deep/ .el-input {
    width: 100%;
  }

  .student-select-button {
    flex-shrink: 0;
  }

  .student-list-panel {
    border-radius: 16px;
    background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
    border: 1px solid #dfeafb;
    overflow: hidden;
  }

  .student-list-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    background: linear-gradient(90deg, #78a5e7 0%, #91b7ef 100%);
  }

  .student-list-title {
    margin: 0 0 4px;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
  }

  .student-list-subtitle {
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
  }

  .student-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 220px;
    padding: 24px;
    text-align: center;
    color: #606266;
  }

  .student-empty-state__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: #edf4ff;
    color: #78a5e7;
    font-size: 28px;
  }

  .student-empty-state__title {
    color: #303133;
    font-size: 18px;
    font-weight: 700;
  }

  .student-empty-state__desc {
    max-width: 380px;
    line-height: 1.6;
  }

  .answer_apply {
    max-height: 260px;
    padding: 16px;
    overflow: auto;
  }

  .kid-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    background: #fff;
  }

  .kid-row + .kid-row {
    margin-top: 10px;
  }

  .kid-row__icon-wrap {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(103, 194, 58, 0.12);
  }

  .kid-row__icon {
    color: #67c23a;
    font-size: 16px;
  }

  .kid-row__content {
    min-width: 0;
  }

  .kid-row__name {
    color: #303133;
    font-weight: 600;
    line-height: 1.5;
    word-break: break-word;
  }

  .kid-row__meta {
    margin-top: 2px;
    color: #909399;
    line-height: 1.5;
    word-break: break-word;
  }

  .upload-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 18px;
  }

  .upload-note-card {
    padding: 12px 16px;
    border-radius: 14px;
    background: #fff8eb;
    border: 1px solid #f6dca7;
  }

  .upload-note-card__label {
    display: block;
    margin-bottom: 4px;
    color: #c48a13;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .upload-note-card__value {
    color: #8a5b00;
    font-size: 16px;
  }

  .upload-progress {
    width: 320px;
    max-width: 100%;
  }

  .upload-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .selected-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 10px;
    border-radius: 12px;
    background: #f6f9ff;
    border: 1px solid #e6eefc;
  }

  .selected-summary__thumb {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(31,45,61,0.06);
  }

  .selected-summary__text {
    font-size: 13px;
    color: #303133;
    font-weight: 600;
  }

  .selected-summary__empty {
    color: #909399;
    font-size: 13px;
  }

  .upload-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 220px;
  }

  .progress-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .progress-label {
    color: #303133;
    font-weight: 700;
    font-size: 13px;
    min-width: 40px;
    text-align: right;
  }

  .clear-selected {
    color: #c23535;
    font-size: 13px;
  }

  .upload-area /deep/ .el-upload--picture-card,
  .upload-area /deep/ .el-upload-list--picture-card .el-upload-list__item {
    border-radius: 16px;
  }

  .upload-area /deep/ .el-upload--picture-card {
    width: 160px;
    height: 160px;
    border: 1px dashed #b8cdf3;
    background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .upload-area /deep/ .el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
  }

  .upload-trigger {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 6px 8px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    color: #5b84c4;
  }

  .upload-trigger__icon {
    font-size: 20px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .upload-trigger__text {
    font-size: 15px;
    font-weight: 600;
  }

  .actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .button-over {
    min-width: 148px;
    border-radius: 10px;
    box-shadow: 0 8px 20px rgba(48, 49, 51, 0.08);
  }

  .cancel-link {
    text-decoration: none;
  }

  /deep/ .el-form-item__label {
    color: #303133;
    font-weight: 600;
  }

  /deep/ .el-input .el-input__inner,
  /deep/ .el-select .el-input__inner,
  /deep/ .el-textarea__inner {
    border-radius: 10px;
    border-color: #dbe4f0;
    transition: all 0.2s ease;
  }

  /deep/ .el-input .el-input__inner,
  /deep/ .el-select .el-input__inner {
    height: 42px;
    line-height: 42px;
  }

  /deep/ .el-input .el-input__inner:focus,
  /deep/ .el-select .el-input__inner:focus,
  /deep/ .el-textarea__inner:focus {
    border-color: #78a5e7;
    box-shadow: 0 0 0 3px rgba(120, 165, 231, 0.12);
  }

  /deep/ .el-textarea__inner {
    min-height: 120px !important;
  }

  .container_image_upload {
    position: relative;
    height: 100%;

    img {
      object-fit: cover;
    }
  }

  @media (max-width: 992px) {
    .page-header-card,
    .section-heading--space-between {
      flex-direction: column;
      align-items: flex-start;
    }

    .header-badges {
      width: 100%;
    }

    .summary-badge {
      flex: 1 1 180px;
    }
  }

  @media (max-width: 768px) {
    .page-header-card,
    .form-shell {
      border-radius: 14px;
    }

    .page-header-card,
    .form-shell,
    .section-card {
      padding: 16px;
    }

    .section-card + .section-card {
      margin-top: 16px;
    }

    .actions-wrap {
      flex-direction: column;
      align-items: stretch;
    }

    .cancel-link,
    .actions-wrap /deep/ .el-button {
      width: 100%;
    }

    .button-over {
      min-width: 100%;
    }
  }
}
</style>
